import { RichCell, Separator, Text, Caption } from '@vkontakte/vkui';
import { UsersStack } from '../../components/UsersStack';
import { useAppContext } from '../../../AppContext';
import PropTypes from 'prop-types';
import { EventItemImageType, PaymentDistributionTypes } from '../../../Types';
import { ItemNameBlock } from './ItemsBlockComponent';

const PaymentTypeComponent = ({id, name, comment, amount, date, distribution_type, creator_id, images, members, users, onClick}) => {
  const context = useAppContext();
  const creator = users[creator_id];

  return (<>
    <RichCell
      multiline
      caption={<>
        <Caption weight={'3'} level={'1'} className={'PaymentRow__comment'} >{comment.length > 1 ? comment : (<>&nbsp;</>)}</Caption>
      </>}
      after={<div className={'PaymentRow__rightBlock'}>
        <Text>{context.lang().formatPrice(amount)}</Text>
        <Caption>{context.lang().dateFormatShort(date)}</Caption>
      </div>}
      actions={<UsersStack users={members.map((item) => users[item.id])} />}
      onClick={onClick}
    >
      <ItemNameBlock title={name} user={creator} />
    </RichCell>
    <Separator/>
  </>);
}

export default PaymentTypeComponent;

PaymentTypeComponent.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  comment: PropTypes.string,
  amount: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  distribution_type: PaymentDistributionTypes.isRequired,
  creator_id: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(EventItemImageType).isRequired,
  // members: PropTypes.arrayOf(PropTypes.number).isRequired,
  // users: PropTypes.objectOf(MemberType).isRequired,
  parts: PropTypes.object,
  values: PropTypes.object,
};
